"use client"

import { useSearchParams } from 'next/navigation';

const ReferralCode = () => {
  const searchParams = useSearchParams()
  const referralCode = searchParams.get('referral_code');
  return referralCode && <input className='hidden' type='hidden' name='referral_code' defaultValue={referralCode} />
}

export default ReferralCode